import React from 'react';
import { useParams } from 'react-router';
import { useStartDecisionTreeRunMutation } from '../../../../../generated/core-api/graphql-react-query';
import useLiveContext from '../../../../LiveContext/useLiveContext';
import UnauthorizedPage from './UnauthorizedPage';

export const DecisionTreePreviewContext = React.createContext<boolean>(false);

export default function useDecisionTreePreviewContext() {
  return React.useContext(DecisionTreePreviewContext);
}

export function DecisionTreePreviewContextProvider(props: { children: React.ReactNode }) {
  const { children } = props;
  const { projectId } = useLiveContext();
  const { decisionTreeId } = useParams<{ decisionTreeId: string }>();
  const { decisionTreeState: { setRunId } } = useLiveContext();

  const mutation = useStartDecisionTreeRunMutation<Error>({
    onSuccess(data) {
      setRunId(data.startDecisionTreeRun.id);
    },
    onError(error) {
      console.error('Error starting preview decision tree run', error);
    },
  });

  React.useEffect(() => {
    if (decisionTreeId) {
      mutation.mutate({ input: { id: decisionTreeId, isPreviewRun: true } });
    }
  }, []);

  if (mutation.error && mutation.error.message === 'Unauthorized') {
    return <UnauthorizedPage projectId={projectId} />;
  }

  return (

    <DecisionTreePreviewContext.Provider value>
      {children}
    </DecisionTreePreviewContext.Provider>
  );
}
